function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

/** 公告文案白名单清洗 */
function sanitizeNoticeHtml(html: string): string {
  let s = html.replace(/<(?!\/?(?:p|br|span|font|b|strong)\b)[^>]*>/gi, '')
  s = s.replace(/\s+on\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
  s = s.replace(/javascript\s*:/gi, '')
  s = s.replace(/\sstyle\s*=\s*("([^"]*)"|'([^']*)')/gi, (_m, _q, d1, d2) => {
    const style = d1 || d2 || ''
    const cm = style.match(/color\s*:\s*([^;]+)/i)
    if (!cm) return ''
    const color = String(cm[1]).trim()
    if (/^(#[0-9a-fA-F]{3,8}|rgb\s*\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)|[a-zA-Z]+)$/.test(color)) {
      return ` style="color:${color}"`
    }
    return ''
  })
  s = s.replace(/\scolor\s*=\s*("([^"]*)"|'([^']*)'|([^\s>]+))/gi, (_m, _a, d1, d2, d3) => {
    const color = String(d1 || d2 || d3 || '').trim()
    if (/^(#[0-9a-fA-F]{3,8}|rgb\s*\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)|[a-zA-Z]+)$/.test(color)) {
      return ` color="${color}"`
    }
    return ''
  })
  return s
}

/** 公告文案转安全 HTML：支持标红；纯文本兼容换行 */
export function formatNoticeHtml(raw: string, fallback = ''): string {
  let text = String(raw || '').trim()
  if (!text) {
    text = String(fallback || '').trim()
  }
  if (!text) {
    return ''
  }
  if (!/<\/?[a-z][\s\S]*>/i.test(text)) {
    return escapeHtml(text).replace(/\n/g, '<br>')
  }
  return sanitizeNoticeHtml(text)
}

/** 纯文本（van-notice-bar） */
export function stripNoticeText(raw: string): string {
  return String(raw || '')
    .replace(/<[^>]+>/g, '')
    .replace(/\s+/g, ' ')
    .trim()
}
